<template>
  <div class="prize-table">
    <tiktok-prize-dialog :prizeCount="options.total" ref="tiktokPrizeDialog"></tiktok-prize-dialog>
    <el-table class="mb-x2" :data="prizes" stripe @header-click="headerClick" empty-text=" " style="width: 100%">
      <el-table-column label="応募グループ名" sort-by="name" :render-header="renderHeader" min-width="25%">
        <template slot-scope="scope">
          <div class="link" @click="openCampaignApplicant(scope.row.id)">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="応募キーワード" sort-by="entryKeyword" :render-header="renderHeader" min-width="37%">
        <template slot-scope="scope" v-if="getKeyword(scope.row.entryKeyword)"
          ><span class="text-disabled mr-x1">全て含む</span
          ><span>{{ getKeyword(scope.row.entryKeyword) }}</span></template
        >
      </el-table-column>
      <el-table-column label="応募者数" sort-by="-applicantCount" :render-header="renderHeader" min-width="10%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.applicantCount) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="当選者数" sort-by="-winnerCount" :render-header="renderHeader" min-width="10%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.winnerCount) }}</div>
          <div class="sub-value">残り:&nbsp;{{ formatNumber(scope.row.maxWinnerCount - scope.row.winnerCount) }}</div>
        </template>
      </el-table-column>
      <el-table-column min-width="8%">
        <template slot-scope="scope">
          <div layout layout-align="end">
            <el-tooltip :enterable="false" placement="top" content="編集">
              <el-button class="el-button--icon" type="default" @click="openCampaignDialogEdit(scope.row.id)"
                ><i class="mdi mdi-table-edit"></i
              ></el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        :type="campaign.snsType"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
      ></pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.text-disabled {
  font-size: $font-small-size;
}

.sub-value {
  font-size: $font-small-size;
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
import Pagination from '@/client/components/_atoms/pagination'
import Util from '@/client/core/util'
import TiktokPrizeDialog from '@/client/features/tiktok_campaign_prize/tiktok_prize_dialog'
import { formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useTikTokCampaignPrizeStore } from '@/client/store/useTikTokCampaignPrizeStore'

export default defineComponent({
  props: {
    prizes: Array,
    options: Object,
    onChangePagingNo: Function,
    onChangeLimitCount: Function,
    onChangeSortBy: Function
  },
  components: {
    Pagination,
    Icon,
    TiktokPrizeDialog
  },
  computed: {
    ...mapState(useTikTokCampaignPrizeStore, {
      campaign: state => {
        if (state.campaign) {
          return state.campaign
        }
        return {}
      }
    })
  },
  methods: {
    formatNumber,

    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      switch (column.label) {
        case '応募グループ名':
          TrackingService.sendEvent('sort:応募グループ一覧（TikTok）|応募グループ名')
          break
        case '応募キーワード':
          TrackingService.sendEvent('sort:応募グループ一覧（TikTok）|応募キーワード')
          break
        case '応募者数':
          TrackingService.sendEvent('sort:応募グループ一覧（TikTok）|応募者数')
          break
        case '当選者数':
          TrackingService.sendEvent('sort:応募グループ一覧（TikTok）|当選者数')
          break
        default:
          break
      }

      if (!column.sortBy) {
        return
      }
      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.options.sortBy, column.sortBy))
    },

    /**
     * 応募キーワード取得
     * @param {string[]} prizeKeyword
     */
    getKeyword(prizeKeyword: string[]) {
      if (!prizeKeyword) {
        prizeKeyword = []
      }

      if (this.campaign.setting && this.campaign.setting.entryActionType !== 'comment') {
        prizeKeyword = JSON.parse(this.campaign.setting.searchKeyword).concat(prizeKeyword)
      }

      return prizeKeyword.join(' ')
    },

    openCampaignApplicant(id: number) {
      TrackingService.sendEvent('click:応募グループ一覧（TikTok）|グループ名')

      this.$router.push('/tiktok_campaigns/' + this.campaign.id + '/prizes/' + id + '/applicants')
    },

    openCampaignDialogEdit(id: number) {
      TrackingService.sendEvent('click:応募グループ一覧（TikTok）|編集')

      this.$refs.tiktokPrizeDialog.open(this.campaign.id, id)
    }
  }
})
</script>
